import React from 'react';
import TelegramMessage from './form';
import {notification} from 'antd';
import history from '../../modules/History';
import {addTelegramMessage} from '../../modules/Api';
import e from 'cors';
class AddTelegramMessage extends React.Component {
    constructor() {
        super();
        this.state = {
            data: {
                type : null,
                text : null,
                media : null,
                link_title : null,
                link : null
            },
            submitted: false,
            
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = values;
        addTelegramMessage(formData, (res) => {
            if(res.status && res.status==200) {
                if(res.data.errors){
                    this.setState({submitted:false});
                    notification.open({
                        message: 'خطایی رخ داده است. لطفا مقادیر وارد شده را بررسی کنید',
                        description: res.message
                    });
                }else{
                    notification.open({
                        message: `تبلیغ با موفقیت در صف قرار گرفته شد!`,
                        description: ``
                    });
                }
               
                // history.item.push(`/ads-modal`);
            }
            else{
                notification.open({
                    message: 'خطایی رخ داده است.',
                    description: res.message
                });
            }
        });
    }
    render() {
        return (<div><TelegramMessage initialData={this.state.data} submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddTelegramMessage;


// WEBPACK FOOTER //
// ./src/containers/TelegramMessage/index.js